<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Связи</h5>
      <template v-if="connections?.length">
        <p class="mb-2 text-muted">Найдено связанных организаций: {{ connections.length }}</p>
        <ul class="info-list mt-2">
          <li class="d-flex flex-row border-bottom align-items-end py-2">
            <span class="info-value">Действующие</span><span class="info-bold">{{ activeConnections?.length }}</span>
          </li>
          <li class="d-flex flex-row border-bottom align-items-end py-2">
            <span class="info-value">Прошлые</span
            ><span class="info-bold">{{ connections.length - activeConnections?.length }}</span>
          </li>
          <li class="d-flex flex-row align-items-end pt-2">
            <span class="info-value">Типов связей</span><span class="info-bold">{{ relationTypes.length }}</span>
          </li>
        </ul>
      </template>
      <template v-else><p>Нет данных</p> </template>
      <button class="btn-primary btn-small d-block ms-auto mt-2" @click="emitChangeTab('tab-connections')">
        Подробнее
      </button>
    </div>
  </div>
</template>

<script>
  import { computed } from 'vue';

  export default {
    name: 'ConnectionsInfo',
    emits: ['change-tab'],
    props: {
      connections: {
        type: Array,
        default: () => [],
      },
    },
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    setup(props, { emit }) {
      const emitChangeTab = (newTab) => {
        emit('change-tab', newTab);
      };
      const activeConnections = computed(() => {
        return (props.connections || []).filter((connection) => connection.status === 'Действует');
      });
      const relationTypes = computed(() => {
        const types = new Set();
        (props.connections || []).forEach((connection) => {
          (connection.relations || [connection.relation_type]).filter(Boolean).forEach((type) => types.add(type));
        });
        return Array.from(types);
      });

      return {
        activeConnections,
        relationTypes,
        emitChangeTab,
      };
    },
  };
</script>
